<template>
    <footer class="m-4 text-white">
        <div class="w-full mx-auto max-w-screen-xl p-4 md:flex md:items-center md:justify-between">
          <span class="text-sm text-sky-500 sm:text-center dark:text-sky-400">© 2024 L'assurance maladie. Tous droits
            réservés.
          </span>
        </div>
      </footer>
</template>